module.exports = __webpack_public_path__ + "static/media/engineer-monitor.ca42303e.png";